import React from 'react'

type Props = {
    className?      : string

    option          : Option

    isHighlighted   : boolean
    isSelected      : boolean

    onClick         : func
}

export default function OptionPill(props: Props) {

    const onClick = () => {
        props.onClick(props.option)
    }

    const classes = Classes('option', 'pill', {
        'highlighted': props.isHighlighted
    })

    const valueClasses = Classes('ui5-pillbox s26 w200', {
        ['gd-c-bgp-'+props.option.color]            : !!props.option.color,
        ['gd-c-pale-border-'+props.option.color]    : !!props.option.color,
    })

    return (
        <div className={classes} onClick={onClick}>
            {!props.option.isAllValuesOption &&
                <div className={Classes("ui5-cb s-16 fl-no-shrink m-r-10", props.className, {selected: props.isSelected})}/>}
            <div className={valueClasses}>{props.option.label}</div>
        </div>
    )
}